<template>
  <div class="shipped-order-page">
    <common-title titleName="物流详情" :bcColor="'#FEFEFF'" :zIndex="1000"></common-title>
    <div class="empty" v-if="!$root.$data.isApp"></div>
    <section>
      <van-tabs
          title-active-color="#FF6C02"
          title-inactive-color="#333"
          color="#FF6C02"
          line-width="22.5px"
          line-height="2.5px"
          v-model="activeName"
          @change="tabsChange"
          :offset-top="$root.$data.isApp?0:'1.333rem'"
          sticky
      >
        <van-tab
            v-for="(item,index) in pageTab"
            :title="item.title"
            :name="item.name"
            :key="index"
        >
          <commonLoading v-if="loading"/>
          <components :is="item.name" v-else-if="frontData.length>0" :frontData="frontData"/>
          <emptyData :emptyName="item.name" v-else/>
        </van-tab>
      </van-tabs>
    </section>
  </div>
</template>

<script>
// eslint-disable-next-line import/extensions
import delivered from '@/pages/personalCenter/myIndent/shippedOrder/components/delivered';
// eslint-disable-next-line import/extensions
import toBeDelivered from '@/pages/personalCenter/myIndent/shippedOrder/components/toBeDelivered';
import CommonTitle from '@/components/header/CommonTitle.vue';
import { reqGetFrontList } from '@/api/personal/shippedOrder';
// eslint-disable-next-line import/extensions
import commonLoading from '@/components/commonComponents/CommonLoading';
// eslint-disable-next-line import/extensions
import emptyData from '@/components/emptyData/emptyData';

export default {
  components: {
    delivered, toBeDelivered, CommonTitle, commonLoading, emptyData,
  },
  data() {
    return {
      activeName: 'a',
      pageTab: [
        {
          title: '已发货',
          name: 'delivered',
        }, {
          title: '待发货',
          name: 'toBeDelivered',
        },
      ],
      frontData: [],
      loading: true,
    };
  },
  mounted() {
    if (!this.$route.params.tab) {
      this.$router.replace({ path: '/shippedOrder/delivered', query: this.$route.query });
    } else {
      this.activeName = this.$route.params.tab;
    }
    this.getFrontList();
  },
  methods: {
    tabsChange(val) {
      this.$router.replace({ path: `/shippedOrder/${val}`, query: this.$route.query });
      this.loading = true;
      this.getFrontList();
    },
    async getFrontList() {
      try {
        if (!this.$route.query.orderNo) {
          this.loading = false;
          this.$toast('获取订单信息失败！');
          return;
        }
        this.frontData = [];
        const status = this.$route.params.tab === 'delivered' ? 2 : 1;
        const res = await reqGetFrontList(this.$route.query.orderNo, status);
        this.loading = false;
        if (res.code === 0) {
          this.frontData = res.data;
        } else {
          this.$toast(res.msg || '网络错误');
        }
      } catch (error) {
        this.$toast(error.message);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.shipped-order-page {
  .empty {
    height: 100px;
  }
}
</style>
